// extracted by mini-css-extract-plugin
export default {"root":"ConfirmationActivationModal_root__QcHe0","sub-header":"ConfirmationActivationModal_sub-header__Zg2um"};